<script setup lang="ts">
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useToast } from 'primevue/usetoast';
import { useConfigParserStore } from '~/stores/configParser';
import ConfigFormTabs from '../base/forms/ConfigFormTabs.vue';

const { t } = useI18n();
const toast = useToast();

const props = defineProps<{ groupId: number | null }>();
const emit = defineEmits<{ (e: 'close'): void; (e: 'created'): void }>();

const configParserStore = useConfigParserStore();

const configData = computed(() => configParserStore.getOrganizedConfigData);

</script>

<template>
  <div class="config-profile-container">
    <ConfigFormTabs
      :config-data="configData"
      :delete-categories="undefined"
      :show-title="false"
      :show-delete-button="false"
      :profile-settings="true"
      @focus-next="() => {}"
      @reload-config="() => {}"
    />
  </div>
</template>

<style scoped>
.config-profile-container {
  padding: 1rem;
}
</style>